import { FC, useState } from 'react';
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
} from '@mui/material';
import { Example } from '@/lib/interfaces/ApiControl';
import ContentRenderer from '../Content/ContentRenderer';

type ApiControlExamplesProps = {
	examples: Example[];
};

const ApiControlExamples: FC<ApiControlExamplesProps> = ({ examples }) => {
	const [currentExample, setCurrentExample] = useState<string>(examples[0]?.id);
	const handleChange = (event: SelectChangeEvent) => {
		setCurrentExample(event.target.value);
	};
	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<FormControl sx={{ m: 1, maxWidth: 220 }} size="small">
				<InputLabel id="demo-select-small-label">Example</InputLabel>
				<Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={currentExample}
					label="Example"
					onChange={handleChange}
				>
					{examples.map((item) => (
						<MenuItem value={item.id}>{item.title}</MenuItem>
					))}
				</Select>
			</FormControl>
			<div style={{ width: '100%' }}>
				<ContentRenderer
					html={
						examples.find((item) => item.id === currentExample)?.description || ''
					}
				/>
			</div>
		</div>
	);
};

export default ApiControlExamples;
